export const SOCIAL_LINKS = [
  {
    name: 'facebook',
    url: 'https://www.facebook.com/profile.php?id=61591578909351',
  },
  {
    name: 'instagram',
    url: 'https://www.instagram.com/padelzalau/',
  },
] as const
